import { render, staticRenderFns } from "./Informant.vue?vue&type=template&id=60063b8f&"
import script from "./Informant.vue?vue&type=script&lang=js&"
export * from "./Informant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports